import { Link } from "react-router-dom"
import { siteConfig } from "@/components/homepage/_config"
import { Icons } from "@/components/homepage/ui/Icons"

export function HomepageFooter() {
    return (
        <footer className="w-full">
            <div className="py-12 px-8 md:px-14">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                    <div className="col-span-2 md:col-span-1 flex flex-col gap-4">
                        <Icons.logo className="text-2xl" />
                        <p className="text-sm text-muted-foreground text-balance">
                            Create stunning videos with AI. Footage writes creative briefs, generates clips, and refines every frame so you can focus on storytelling.
                        </p>
                        <div className="flex items-center gap-3">
                            <a href="https://x.com/footageai" target="_blank" rel="noopener noreferrer" className="text-foreground hover:text-foreground/70 transition-colors">
                                <svg className="size-4" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
                            </a>
                            <a href="https://www.linkedin.com/company/footagecom/" target="_blank" rel="noopener noreferrer" className="text-foreground hover:text-foreground/70 transition-colors">
                                <svg className="size-4" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
                            </a>
                        </div>
                    </div>
                    {siteConfig.footerLinks.map((group) => (
                        <div key={group.title}>
                            <h4 className="text-sm font-medium mb-3">{group.title}</h4>
                            <ul className="space-y-2">
                                {group.links.map((link) => {
                                    const isExternal = link.url.startsWith('mailto:') || link.url.includes('.')
                                    return (
                                        <li key={link.id}>
                                            {isExternal ? (
                                                <a
                                                    href={link.url}
                                                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                                                >
                                                    {link.title}
                                                </a>
                                            ) : (
                                                <Link
                                                    to={link.url}
                                                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                                                >
                                                    {link.title}
                                                </Link>
                                            )}
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
            <div className="border-t border-border py-6">
                <p className="text-sm text-muted-foreground text-center">
                    &copy; {new Date().getFullYear()} {siteConfig.company} All rights reserved.
                </p>
            </div>
        </footer>
    )
}
